const formatDate = (dateString: string): string => {
  const date = new Date(dateString);

  if (isNaN(date.getTime())) {
    return 'Invalid Date NaN:NaN:NaN';
  }

  const formattedDate = date.toISOString().split('T')[0];
  const formattedTime = date.toLocaleTimeString();

  return `${formattedDate} ${formattedTime}`;
};

export default formatDate;
